import { InputField, RadioGroup } from '@cashfree-intl/coherent';
import styled from 'styled-components';

export const StyledRadioGroup = styled(RadioGroup)`
  & .ui.checked.checkbox label::before {
    border: 2px solid rgb(105, 48, 202) !important;
  }
  &.ui.checkbox label {
    color: rgba(0, 0, 0, 0.87);
  }
  & input:checked ~ label::after {
    background-color: rgb(105, 48, 202) !important;
    top: 1px !important;
  }
`;

export const StyledInputField = styled(InputField)`
  & input {
    // eslint-disable-next-line prettier/prettier
    max-width: ${props => props.maxWidth ? `${props.maxWidth} !important` : ''};
    width: ${props => (props.width ? `${props.width} !important` : '')};
  }
`;
